import { render, staticRenderFns } from "./SubSubTest.vue?vue&type=template&id=408fa807&scoped=true&"
import script from "./SubSubTest.vue?vue&type=script&lang=js&"
export * from "./SubSubTest.vue?vue&type=script&lang=js&"
import style0 from "./SubSubTest.vue?vue&type=style&index=0&id=408fa807&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408fa807",
  null
  
)

export default component.exports